/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastpasswordchange2Inputs */

const de__field_lastpasswordchange2 = /** @type {(inputs: _Field_Lastpasswordchange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Passwortänderung`)
};

/**

* @param {_Field_Lastpasswordchange2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastpasswordchange2 = /** @type {((inputs?: _Field_Lastpasswordchange2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastpasswordchange2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastpasswordchange2(inputs)
});
export { _field_lastpasswordchange2 as "_field_lastPasswordChange" }